export const Notification = {
  NO_WALLET: "Connect a wallet before start.",
  CONNECTED: "Logged in.",
  DISCONNECT: "Disconnected.",
  AUTHORIZE_WALLET: "Authorizing your UNFI usage.",
  CLAIM_SUCCESSFUL: "Your claim has been processed.",
  CLAIM_FAILED: "Your claim has failed.",
  STAKE_SUCCESSFUL: "Your stake has been processed.",
  STAKE_FAILED: "Your stake has failed.",
  DEPOSIT_SUCCESSFUL: "Your deposit has been processed.",
  DEPOSIT_FAILED: "Your deposit has failed.",
  UNSTAKE_SUCCESSFUL: "Your unstake has been processed.",
  UNSTAKE_FAILED: "Your unstake has failed.",
  INVALID_AMOUNT:
    "Typed amount is invalid - Is not a number or is greater than your balances.",
  INVALID_ADDRESS: "Typed address is not a valid Ethereum address.",
};

export type NotificationType = keyof typeof Notification;
